import React, { Suspense, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  getAssessmentDetails,
  getDownloadPdf,
  getUserQuestionnairestatuses } from
'../../../services/liferay/baraemServices';
import { configureFirstIframe, isArabic, isMobileApp, openPdfToUrl } from "../../../utils/util";
import DocModal from "./DocModal";
import { Loader } from '../../../common/Loader';

const calculateAgeInMonths = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();
  const ageInMonths =
  (today.getFullYear() - birthDate.getFullYear()) * 12 +
  today.getMonth() -
  birthDate.getMonth();
  return ageInMonths > 0 ? ageInMonths : 0;
};

const calculateFirstAssessmentDate = (dob, chronologicalAgeMonths, prematureWeeks) => {


  const birthDate = new Date(dob);

  const dobBasedMonths = calculateAgeInMonths(dob);


  let effectiveBirthDate = new Date(birthDate);

  if (chronologicalAgeMonths <= dobBasedMonths) {
    const prematurityDays = (parseInt(prematureWeeks, 10) || 0) === 3 ? 0 : (parseInt(prematureWeeks, 10) || 0) * 7;
    effectiveBirthDate.setDate(effectiveBirthDate.getDate() + prematurityDays);
  }


  const startDate = new Date(effectiveBirthDate);
  startDate.setMonth(startDate.getMonth() + 9);


  return startDate.toLocaleDateString("en-GB");


};
const formatToMonthDayYear = (date) => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(date).toLocaleDateString('en-GB', options);
};

const calculateAssessmentDates = (dob, fromage, toage, chronologicalAgeMonths, prematureWeeks) => {
  const birthDate = new Date(dob);

  const dobBasedMonths = calculateAgeInMonths(dob);


  let effectiveBirthDate = new Date(birthDate);
  if (dobBasedMonths < 24) {
    if (chronologicalAgeMonths < dobBasedMonths) {
      const prematurityDays = (parseInt(prematureWeeks, 10) || 0) === 3 ? 0 : (parseInt(prematureWeeks, 10) || 0) * 7;
      effectiveBirthDate.setDate(effectiveBirthDate.getDate() + prematurityDays);
    }
  }

  const startDate = new Date(effectiveBirthDate);
  startDate.setMonth(startDate.getMonth() + fromage);

  const endDate = new Date(effectiveBirthDate);
  if (fromage === 60 && toage === 72) {
    endDate.setMonth(endDate.getMonth() + toage);
    endDate.setDate(effectiveBirthDate.getDate() - 1);

  } else {
    endDate.setMonth(endDate.getMonth() + toage + 1);
    endDate.setDate(effectiveBirthDate.getDate() - 1);
  }

  return {
    startDate: formatToMonthDayYear(startDate),
    endDate: formatToMonthDayYear(endDate)
  };
};

const DevelopmentHistory = ({ selectedChild, translationMap, chronologicalAgeMonths }) => {
  const [loading, setLoading] = useState(true);
  const [, setAssessments] = useState([]);
  const [childAge, setchildAge] = useState(0);
  const [, setQuestionnaireStatus] = useState([]);
  const [listOfDevelopmentHistory, setListOfDevelopmentHistory] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [url, setUrl] = useState("");
  const [base64, setBase64] = useState(null);
  const [assesmentName, setAssesmentName] = useState("");
  const [isViewReportLoading, setIsViewReportLoading] = useState(false);
  const [isLastAgeGroup, setIsLastAgeGroup] = useState(false);
  const [, setNextStartMonth] = useState(null);
  const [formattedNextStartDate, setFormattedNextStartDate] = useState("");
  const [showCurrentDetails, setShowCurrentDetails] = useState(true);

  const closeModal = () => {
    window.parent.scrollTo(0, 0);
    setShowModal(false);

  };

  useEffect(() => {
    const fetchAssessment = async () => {
      try {
        const assessment = await getAssessmentDetails();
        if (assessment.status === 200) {
          setAssessments(assessment.data.data.items);
        }

        const childAgeInMonths = chronologicalAgeMonths;
        setchildAge(childAgeInMonths);

        const questionStatus = await getUserQuestionnairestatuses(selectedChild.healthCardNumber || selectedChild.childId);
        if (questionStatus.status === 200) {
          setQuestionnaireStatus(questionStatus.data.data.items);
        }

        const nextAssessment = assessment.data.data.items
        .filter((item) => childAgeInMonths < item.fromage)
        .sort((a, b) => a.fromage - b.fromage)[0];

        if (nextAssessment) {
          setNextStartMonth(nextAssessment.fromage);
          setIsLastAgeGroup(false);

          const { startDate } = calculateAssessmentDates(
            selectedChild.dob,
            nextAssessment.fromage,
            10,
            chronologicalAgeMonths,
            selectedChild.prematurity
          );

          const dateParts = startDate.split(" ");
          const monthNumber = new Date(`${dateParts[1]} 1, 2000`).getMonth() + 1;
          const formattedDate = `${dateParts[0]}/${monthNumber.toString().padStart(2, "0")}/${dateParts[2]}`;

          setFormattedNextStartDate(formattedDate);
        } else {
          setNextStartMonth(0);
          setIsLastAgeGroup(true);
          setFormattedNextStartDate("");
        }

        const combinedHistory = questionStatus.data.data.items.map((statusItem) => {
          const matchedAssessment = assessment.data.data.items.find(
            (assessment) => assessment.questionnaireid === statusItem.questionnaireid
          );

          if (matchedAssessment) {
            const { startDate, endDate } = calculateAssessmentDates(
              selectedChild.dob,
              matchedAssessment.fromage,
              matchedAssessment.toage,
              chronologicalAgeMonths,
              selectedChild.prematurity
            );

            return {
              status: statusItem.baraemStatus,
              startDate,
              endDate,
              name: matchedAssessment.name,
              questionnaireId: statusItem.questionnaireid,
              tbluserQuestionnaireStatus: statusItem.id
            };
          }
          return null;
        }).filter(Boolean);

        setListOfDevelopmentHistory(combinedHistory);

      } catch (error) {
        console.error("Error fetching assessments:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAssessment();
  }, [selectedChild, chronologicalAgeMonths]);




  async function handleViewBaraemReport(ageRange, hcNumber, questionnaireId, selectedChild) {
    try {
      window.parent.scrollTo(0, 0);
      setIsViewReportLoading(true);
      delete selectedChild["imageBase64"];

      const user = {

        "hcNumber": hcNumber,

        "questionnaireId": questionnaireId,
        "childDetails": selectedChild
      };
      // console.log("view payload", user);


      const { data: base64 } = await getDownloadPdf(user);

      if (!base64) {
        setIsViewReportLoading(false);
        throw new Error("Base64 data is missing");
      }

      let dataUrl = openPdfToUrl(base64);
      if (dataUrl) {
        setIsViewReportLoading(false);
        setShowModal(true);
        setUrl(dataUrl);
        setBase64(base64);
        setAssesmentName(ageRange);
      }

    } catch (error) {
      setIsViewReportLoading(false);
      console.error("Failed to download the health card:", error);

    }


  }

  function formatMonthsRange(input) {
    const regex = /(\d+) months - (\d+) months/;
    const match = input.match(regex);

    if (match) {
      return `${match[1]} - ${match[2]} ${translationMap?.months ?? "months"}`;
    }

    return input;
  }

  const getFirstWord = (str) => {
    if (isArabic()) {
      return str.split(' ')[0] + " " + (translationMap?.developmentHistory ?? "Development History") + " ";
    } else {
      return str.split(' ')[0] + (translationMap?.punctMark ?? "'s") + " " + (translationMap?.developmentHistory ?? "Development History");

    }
  };

  function handleDownloadBaraemReport(e, hcNumber, questionnaireId, selectedChild) {
    delete selectedChild["imageBase64"];

    const requestBody = {

      "hcNumber": hcNumber,

      "questionnaireId": questionnaireId,
      "childDetails": selectedChild
    };

    const button = e.target.closest('.button2');
    button.classList.add("active");

    getDownloadPdf(requestBody)
    .then((res) => {
      let base64 = res.data;
      if (!base64) {
        throw new Error("Base64 data is missing");
      }
      const downloadLink = document.createElement('a');
      downloadLink.href = `data:application/pdf;base64,${base64}`;
      downloadLink.download = 'baraem-report.pdf';

      if (isMobileApp()) {
        setTimeout(() => {
          button.classList.remove("active");
          let cardUrl = openPdfToUrl(base64);
          window.open(cardUrl, "_parent");
          const mobilelink = document.createElement("a");
          mobilelink.href = cardUrl;
          mobilelink.download = "BaraemReport.pdf";
          document.body.appendChild(mobilelink);
          mobilelink.click();
          document.body.removeChild(mobilelink);

        }, 2000);

      } else {
        setTimeout(() => {
          button.classList.remove("active");
          button.querySelector("i").classList.replace("fa-download", "fa-check");
          button.querySelector("span").innerText = translationMap?.downloaded;
          button.classList.add("download1");
          downloadLink.click();
        }, 3500);

      }

    })
    .catch((error) => {
      console.error("Failed to download the health card:", error);
    });
  }

  if (loading) {
    return <div>Loading assessments...</div>;
  }

  const pendingItems = listOfDevelopmentHistory.filter((item) => item.status === "pending");
  const inactiveItems = listOfDevelopmentHistory.filter(
    (item) => item.status === "missed" || item.status === "completed"
  );



  if (inactiveItems.length > 3) {

    if (inactiveItems.length <= 5) {
      configureFirstIframe(500, 1800, true);
    } else if (inactiveItems.length <= 7) {
      configureFirstIframe(500, 2200, true);
    } else {
      configureFirstIframe(500, 2600, true);

    }

  }

  if (isViewReportLoading) {
    return (
      <Loader />);

  }
  return (
    <div>
        <div className="baraem_dependent_list_box">
          <h6 className="MainTitleOne" style={{ direction: "ltr" }}>
            <span>
              {getFirstWord(selectedChild.name)}
              
            </span>
            
          </h6>

          {selectedChild.disabilities === "no" ?
        chronologicalAgeMonths >= 9 ?
        <div className="baraem_tab_box">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item">
                    {/* <a
                className="nav-link active"
                id="Current-tab"
                data-toggle="tab"
                href="#Current"
                role="tab"
                aria-controls="Current"
                //   aria-selected="true"
                aria-selected={showCurrentDetails ? "true" : "false"}
                onClick={(e) => {
                e.preventDefault();
                setShowCurrentDetails(true);
                }}
                >
                {translationMap?.current}
                </a> */
              }
                     <button
                role="tab"
                className={`nav-link ${showCurrentDetails ? "active" : ""}`}
                onClick={() => setShowCurrentDetails(true)}>
                
                                        {translationMap?.current}
                                    </button>
                  </li>
                  <li className="nav-item">
                    {/* <a
                className="nav-link"
                id="Previous-tab"
                data-toggle="tab"
                href="#Previous"
                role="tab"
                aria-controls="Previous"
                aria-selected={showCurrentDetails ? "false" : "true"}
                onClick={(e) => {
                e.preventDefault();
                setShowCurrentDetails(false);
                }}
                              >
                {translationMap?.previous}
                </a> */
              }
                     <button
              //  data-toggle="tab"
              role="tab"
              aria-controls="Previous"
              aria-selected="false"

              className={`nav-link ${!showCurrentDetails ? "active" : ""}`}
              onClick={() => setShowCurrentDetails(false)}>
                
                                        {translationMap?.previous}
                                    </button>
                  </li>
                </ul>
                <div className="tab-content" id="myTabContent">
         {showCurrentDetails ?
            <div
              id="Current"
              role="tabpanel"
              aria-labelledby="home-tab">
              
                    
                    <div className="inner_tab_box">
                      {pendingItems.length > 0 &&
                selectedChild.disabilities === "no" ?
                pendingItems.map((item, index) =>
                <div key={index} className="Sick_leave_white_box">
                            <div className="sick_inner_box1">
                              <div className="date_box">
                                <svg
                        width="19"
                        height="22"
                        viewBox="0 0 19 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        
                                  <path
                          d="M17 8.5V5.8C17 4.11984 17 3.27976 16.673 2.63803C16.3854 2.07354 15.9265 1.6146 15.362 1.32698C14.7202 1 13.8802 1 12.2 1L5.8 1C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8L1 16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H11M11 10L5 10M7 14L5 14M13 6L5 6M13.5 14.0022C13.6762 13.5014 14.024 13.079 14.4817 12.81C14.9395 12.5409 15.4777 12.4426 16.001 12.5324C16.5243 12.6221 16.999 12.8942 17.3409 13.3004C17.6829 13.7066 17.87 14.2207 17.8692 14.7517C17.8692 16.2506 15.6209 17 15.6209 17M15.6499 20H15.6599"
                          stroke="#002F70"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round" />
                        
                                </svg>
                              </div>
                              <div className="content_box">
                                <p className="active">
                                  <span className="circle_icon yellow_icon"></span>
                                  {translationMap?.pending}
                                </p>
                                <h6 className="name_txt">
                                  {formatMonthsRange(item.name)}
                                </h6>
                                <ul className="detail_ul_box detail_ul_box2">
                                  <li>
                                    <p>
                                      <span>{translationMap?.startDate}</span>
                                      &nbsp;
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                      <a href="javascript:void(0);">
                                        {item.startDate}
                                      </a>
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      <span>{translationMap?.dueDate}</span>
                                      &nbsp;
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                      <a href="javascript:void(0);">
                                        {item.endDate}
                                      </a>
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="sick_inner_box2">
                              <div className="btn_innerwrap">
                                <div className="common_btn_box">
                                  <Link
                          to="/baraemQuestion"
                          state={{
                            baraemUsername: selectedChild.name,
                            hcNumber: selectedChild.healthCardNumber,
                            questionnaireids: item.questionnaireId,
                            questionnaire: formatMonthsRange(
                              item.name
                            ),
                            age: childAge,
                            tbluserQuestionnaireStatusId:
                            item.tbluserQuestionnaireStatus,

                            childDetails: selectedChild
                          }}
                          className="blue_btn_link"
                          data-toggle="modal"
                          data-target="#documentpdfmodal">
                          
                                    {translationMap?.startQuestionnaire}
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                ) :

                <div className="AlertInnerBox YellowAlertInnerBox">
                          <div className="Icon_box">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                            <a href="javascript:void(0);">
                              <span className="material-symbols-outlined">
                                info
                              </span>
                            </a>
                          </div>
                          <div className="alert_text">
                            <h6>
                              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                              <a href="javascript:void(0);">
                                {selectedChild.name}{" "}
                                {isLastAgeGroup ?
                        translationMap?.noAssessmentText ??
                        "hasn't had any assessments available yet." :
                        `${
                        translationMap?.nextAssesmentText ??
                        "next assessment will be available on"} ${
                        formattedNextStartDate}`}
                              </a>
                            </h6>
                          </div>
                        </div>
                }
                    </div>
                  </div> :
            null} 

         {!showCurrentDetails ?
            <div
              id="Previous"
              role="tabpanel"
              aria-labelledby="Previous-tab">
              
                    <div className="inner_tab_box">
                      {inactiveItems.length > 0 &&
                selectedChild.disabilities === "no" ?
                inactiveItems.map((item, index) =>
                <div key={index} className="Sick_leave_white_box">
                            <div className="sick_inner_box1">
                              <div className="date_box">
                                {item.status === "missed" ?
                      <svg
                        width="19"
                        height="22"
                        viewBox="0 0 19 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        
                                    <path
                          d="M11 10L5 10M7 14L5 14M13 6L5 6M17 11V5.8C17 4.11984 17 3.27976 16.673 2.63803C16.3854 2.07354 15.9265 1.6146 15.362 1.32698C14.7202 1 13.8802 1 12.2 1L5.8 1C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8L1 16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H9M13 15L18 20M18 15L13 20"
                          stroke="#002F70"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round" />
                        
                                  </svg> :

                      <svg
                        width="19"
                        height="22"
                        viewBox="0 0 19 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        
                                    <path
                          d="M17 11.5V5.8C17 4.11984 17 3.27976 16.673 2.63803C16.3854 2.07354 15.9265 1.6146 15.362 1.32698C14.7202 1 13.8802 1 12.2 1L5.8 1C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8L1 16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H9M11 10L5 10M7 14L5 14M13 6L5 6M11.5 18L13.5 20L18 15.5"
                          stroke="#002F70"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round" />
                        
                                  </svg>
                      }
                              </div>
                              <div className="content_box">
                                <p className="active">
                                  <span
                          className={
                          item.status === "missed" ?
                          "circle_icon orange_icon" :
                          "circle_icon active_icon"
                          }>
                        </span>
                                  {
                        translationMap?.[
                        item.status.charAt(0).toUpperCase() +
                        item.status.slice(1)]

                        }
                                  {/* {item.status.charAt(0).toUpperCase() + item.status.slice(1)} */}
                                </p>
                                <h6 className="name_txt">
                                  {formatMonthsRange(item.name)}
                                </h6>
                                <ul className="detail_ul_box detail_ul_box2">
                                  <li>
                                    <p>
                                      <span>{translationMap?.startDate}</span>
                                      &nbsp;
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                      <a href="javascript:void(0);">
                                        {item.startDate}
                                      </a>
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      <span>{translationMap?.dueDate}</span>
                                      &nbsp;
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                      <a href="javascript:void(0);">
                                        {item.endDate}
                                      </a>
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            {item.status === "completed" &&
                  <div className="sick_inner_box2">
                                <div className="btn_innerwrap">
                                  <div className="button2">
                                    <div className="content">
                                      <span
                            className="button-text"
                            onClick={(e) =>
                            handleDownloadBaraemReport(
                              e,
                              selectedChild.healthCardNumber ||
                              selectedChild.childId.toString(),
                              item.questionnaireId,
                              selectedChild
                            )
                            }>
                            
                                        {translationMap?.downloadReport ??
                            "Download Report"}
                                      </span>
                                      <i className="fa-solid fa-download"></i>
                                    </div>
                                  </div>
                                  <div className="common_btn_box">
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <a
                          // eslint-disable-next-line no-script-url
                          href="javascript:void(0);"
                          className="view_btn_link"
                          onClick={() =>
                          handleViewBaraemReport(
                            item.name,
                            selectedChild.healthCardNumber ||
                            selectedChild.childId.toString(),
                            item.questionnaireId,
                            selectedChild
                          )
                          }>
                          
                                      {translationMap?.viewReport ??
                          "View Report"}
                                    </a>
                                  </div>
                                </div>
                              </div>
                  }
                          </div>
                ) :

                <div className="AlertInnerBox YellowAlertInnerBox">
                          <div className="Icon_box">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                            <a href="javascript:void(0);">
                              <span className="material-symbols-outlined">
                                info
                              </span>
                            </a>
                          </div>
                          <div className="alert_text">
                            <h6>
                              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                              <a href="javascript:void(0);">
                                {selectedChild.name}{" "}
                                {translationMap?.noAssessmentText ??
                        "hasn’t had any assessments available yet."}
                              </a>
                            </h6>
                          </div>
                        </div>
                }
                    </div>
                  </div> :
            null}
                </div>
              </div> :

        <div className="AlertInnerBox YellowAlertInnerBox">
                <div className="Icon_box">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                  <a href="javascript:void(0);">
                    <span className="material-symbols-outlined">info</span>
                  </a>
                </div>
                <div className="alert_text">
                  <h6>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                    <a href="javascript:void(0);">
                      {selectedChild.name}
                      {translationMap?.firstAssesmentText ??
                "’s first assessment will be available on"}{" "}
                      {calculateFirstAssessmentDate(
                  selectedChild.dob,
                  chronologicalAgeMonths,
                  selectedChild.prematurity
                )}
                      .
                    </a>
                  </h6>
                </div>
              </div> :


        <div className="AlertInnerBox YellowAlertInnerBox">
              <div className="Icon_box">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                <a href="javascript:void(0);">
                  <span className="material-symbols-outlined">info</span>
                </a>
              </div>
              <div className="alert_text">
                <h6>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                  <a href="javascript:void(0);">
                    {selectedChild.name}{" "}
                    {translationMap?.noAssessmentText ??
                "hasn’t had any assessments available yet."}
                  </a>
                </h6>
              </div>
            </div>
        }
        </div>

        {showModal &&
      <Suspense fallback={<div>Loading...</div>}>
            <DocModal
          show={showModal}
          onClose={closeModal}
          url={url}
          translationMap={translationMap}
          base64={base64}
          assessmentName={formatMonthsRange(assesmentName)} />
        
          </Suspense>
      }
      </div>);

};

export default DevelopmentHistory;